import React, { useEffect, useState } from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { GetConsultantDashBoardData } from "../Services/ConsultantDashboardService";
import NormalAlert from "../../../Alerts/NormalAlert";
import {
  Briefcase,
  Send,
  BookmarkCheck,
  CalendarCheck,
  Repeat,
  ShieldCheck,
  XCircle,
  CheckCircle,
  ArrowRight,
} from "lucide-react";

const ConsultantDashboard = () => {
  const [CountData, SetCountData] = useState({
    AssessmentCount: 0,
    bgv: 0,
    createdJob: 0,
    cvReceived: 0,
    hired: 0,
    hold: 0,
    interviewScheduled: 0,
    publishedJob: 0,
    rejected: 0,
    selected: 0,
    shortlisted: 0,
    cvSent: 0,
  });

  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState(null);

  useEffect(() => {
    const GetDashBoardDataCount = async () => {
      try {
        const response = await GetConsultantDashBoardData();

        if (response) {
          const Count = response.data.dashboardData[0];
          SetCountData((prev) => ({ ...prev, ...Count }));
        }
      } catch (error) {
        const safeMessage =
          error?.response?.data?.message ||
          "Something went wrong. Please try again.";

        setAlert({
          type: "fail",
          message: safeMessage,
        });
      } finally {
        setLoading(false);
      }
    };

    GetDashBoardDataCount();
  }, []);

  const steps = [
    {
      count: CountData.publishedJob,
      title: "Jobs",
      icon: <Briefcase size={40} />,
      link: "/HRSetu/Consultant/Dashboard/All-Jobs",
    },

    {
      count: CountData.cvSent,
      title: "Profile Shared",
      icon: <Send size={40} />,
      link: "/HRSetu/Consultant/Dashboard/Profile-Shared",
    },

    {
      count: CountData.shortlisted,
      title: "Shortlisted",
      icon: <BookmarkCheck size={40} />,
      link: "/HRSetu/Consultant/Dashboard/Shortlisted-Candidates",
    },

    {
      count: CountData.interviewScheduled,
      title: "Interview Scheduled",
      icon: <CalendarCheck size={40} />,
      link: "/HRSetu/Consultant/Dashboard/Interview-Scheduled-Candidates",
    },

    {
      count: CountData.selected,
      title: "Selected",
      icon: <CheckCircle size={40} />,
      link: "/HRSetu/Consultant/Dashboard/Selected-Candidates",
    },
  ];

  return (
    <>
      <div className="w-full min-h-screen bg-[#f3f7fb] flex justify-center pt-20 md:pt-32 px-3 sm:px-4 md:px-6">
        <div className="max-w-[1400px] w-full">
          {loading ? (
            <SkeletonTheme baseColor="#e0e0e0" highlightColor="#f5f5f5">
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-x-4 sm:gap-x-10 md:gap-x-20 gap-y-6 sm:gap-y-10 md:gap-y-16">
                {[...Array(8)].map((_, i) => (
                  <div key={i} className="w-[220px] mx-auto">
                    <Skeleton height={120} borderRadius={12} />
                    <Skeleton height={100} className="mt-2" borderRadius={12} />
                  </div>
                ))}
              </div>
            </SkeletonTheme>
          ) : (
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-x-3 sm:gap-x-6 md:gap-x-8 gap-y-6 sm:gap-y-10 md:gap-y-12 justify-items-center">
              {steps.map((step, i) => (
                <a
                  key={i}
                  href={step.link}
                  className="group w-full max-w-[220px] bg-white rounded-b-xl shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
                  style={{ cursor: step.link ? "pointer" : "default" }}
                >
                  {/* Header */}

                  <div className="bg-gradient-to-br from-[#0d47a1] to-[#42a5f5] text-white h-[110px] px-4 rounded-b-xl flex justify-between items-center">
                    {/* Left (Title + Count) */}
                    <div className="flex flex-col">
                      <div className="text-[13px] sm:text-[15px] md:text-[16px] font-medium">
                        {step.title}
                      </div>

                      <div className="text-[20px] sm:text-[24px] md:text-[26px] font-bold mt-1">
                        {step.count}
                      </div>
                    </div>

                    {/* Right Icon */}
                    <div className="bg-white rounded-full w-12 h-12 flex items-center justify-center text-blue-700 shrink-0">
                      {React.cloneElement(step.icon, { size: 22 })}
                    </div>
                  </div>

                  {/* Bottom Arrow Section */}

                  <div className="flex justify-end px-4 py-3 bg-white rounded-b-xl">
                    <ArrowRight className="text-blue-600" size={20} />
                  </div>
                </a>
              ))}
            </div>
          )}
        </div>
      </div>

      {alert && (
        <NormalAlert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert(null)}
        />
      )}
    </>
  );
};

export default ConsultantDashboard;
